// Get the DOM element for the details box.
const detailsBox = document.querySelector('.section-detailed-feature-box');

/**
 * Display detailed information in the details box.
 *
 * @param {HTMLElement} target - The target element to display details from.
 * @return {boolean} - Indicates whether the operation was successful.
 */
function displayDetailsBox(target) {
    // Check if the target element has a 'data-detail' attribute.
    const detailText = target.dataset.detail || '';

    // Check if the target element has a 'data-detail-title' attribute.
    const titleText = target.dataset.detailTitle || '';

    // Check if the target element has a 'data-detail-link' attribute.
    const link = JSON.parse(target.dataset.link);

    // Check if the target element has a 'data-prev' attribute.
    const prev = target.dataset.prev || false;

    // Check if the target element has a 'data-next' attribute.
    const next = target.dataset.next || false;

    // Set the text of the detail item from the 'data-detail' attribute.
    detailsBox.querySelector('.section-detailed-feature-item__text').innerText =
        detailText;

    // Set the title from the inner text of the target element.
    detailsBox.querySelector(
        '.section-detailed-feature-item__title'
    ).innerText = titleText;

    // Set the link's href attribute from the target's href or a default value.

    const detailedFeatureItemLink = detailsBox.querySelector(
        '.section-detailed-feature-item__link'
    );
    if (detailedFeatureItemLink) {
        if (!link?.url) {
            detailedFeatureItemLink.classList.add('hide');
        } else {
            detailedFeatureItemLink.classList.remove('hide');
            detailedFeatureItemLink.innerHTML = link.title
                ? link.title
                : 'Learn more';
            detailedFeatureItemLink.href = link.url || '#';
            detailedFeatureItemLink.target = link.target || '_self';
        }
    }

    if (prev) {
        detailsBox
            .querySelector('.section-detailed-feature-item__prev')
            .classList.add('active');
    } else {
        detailsBox
            .querySelector('.section-detailed-feature-item__prev')
            .classList.remove('active');
    }

    if (next) {
        detailsBox
            .querySelector('.section-detailed-feature-item__next')
            .classList.add('active');
    } else {
        detailsBox
            .querySelector('.section-detailed-feature-item__next')
            .classList.remove('active');
    }

    detailsBox.querySelector(
        '.section-detailed-feature-item__prev'
    ).dataset.detailedClass = prev;

    detailsBox.querySelector(
        '.section-detailed-feature-item__next'
    ).dataset.detailedClass = next;

    // Add the 'open' class to show the details box.
    detailsBox.classList.add('open');

    // Prevent the default link behavior.
    return false;
}

/**
 * Close the details box by removing the 'open' class.
 *
 * @return {boolean} - Indicates whether the operation was successful.
 */
function closeDetailsBox() {
    detailsBox.classList.remove('open');

    // Prevent the default link behavior.
    return false;
}

// Export the functions for use in other parts of the application.
export { displayDetailsBox, closeDetailsBox };
